module.exports = __webpack_public_path__ + "img/1473770333.8b65c43b.jpg";